export type HelpSearchHaystack = {
  title: string
  summary: string
  body: string
}

export function tokenizeHelpQuery(query: string): string[] {
  return query
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter((token) => token.length > 0)
}

function includesAll(hay: string, tokens: string[]): boolean {
  return tokens.every((token) => hay.includes(token))
}

/** Higher is better. Returns -1 when the article does not match. */
export function scoreHelpArticle(haystack: HelpSearchHaystack, query: string): number {
  const tokens = tokenizeHelpQuery(query)
  if (tokens.length === 0) return 0
  const title = haystack.title.toLowerCase()
  const summary = haystack.summary.toLowerCase()
  const body = haystack.body.toLowerCase()
  const all = `${title}\n${summary}\n${body}`
  if (!includesAll(all, tokens)) return -1

  const phrase = query.trim().toLowerCase()
  let score = 0
  if (title.includes(phrase)) score += 400
  else if (includesAll(title, tokens)) score += 250
  if (summary.includes(phrase)) score += 120
  else if (includesAll(summary, tokens)) score += 80
  if (all.includes(phrase)) score += 40
  for (const token of tokens) {
    if (title.includes(token)) score += 20
    else if (summary.includes(token)) score += 8
    else score += 2
  }
  return score
}
